import React, { createContext, useState, useEffect, ReactNode } from 'react';
import {jwtDecode} from 'jwt-decode'

interface ITokenPayload {
  _id: string;
  role: string;
  exp?: number;
  iat?: number;
}

interface AuthContextType {
  isAuthenticated: boolean;
  role: string | null;
  login: (token: string) => void;
  logout: () => void;
  userId: string | null;
  loading: boolean;
}

export const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false,
  role: null,
  login: () => {},
  logout: () => {},
  loading: true,
  userId: null,
});

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [role, setRole] = useState<string | null>(null);
  const [userId, setUserId] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true); 
  

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwtDecode<ITokenPayload>(token);
        if (decoded.exp && decoded.exp * 1000 < Date.now()) {
          localStorage.removeItem('token');
          setIsAuthenticated(false);
          setRole(null);
          setUserId(null);
        } else {
          setIsAuthenticated(true);
          setRole(decoded.role);
            setUserId(decoded._id);
        }
      } catch (error) {
        console.error('Invalid token', error);
        localStorage.removeItem('token');
        setIsAuthenticated(false);
        setRole(null);
        setUserId(null);
      }
    }
    setLoading(false); 

  }, []);

  const login = (token: string) => {
    localStorage.setItem('token', token);
    try {
      const decoded = jwtDecode<ITokenPayload>(token);
      setIsAuthenticated(true);
      setRole(decoded.role);
      setUserId(decoded._id);
    } catch (error) {
      console.error('Invalid token during login', error);
      setIsAuthenticated(false);
      setRole(null);
        setUserId(null);
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setIsAuthenticated(false);
    setRole(null);
    setUserId(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, role, login,userId, logout,loading }}>
      {children}
    </AuthContext.Provider>
  );
};